import { render, staticRenderFns } from "./I2FormPassword.vue?vue&type=template&id=424b382a&scoped=true&"
import script from "./I2FormPassword.vue?vue&type=script&lang=js&"
export * from "./I2FormPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b382a",
  null
  
)

export default component.exports